import { formatExpiryDate } from "../../utils/formatters";
import styles from "./LotSelectorModal.module.css";

// mode: "add" | "remove" | "workOrder" | "delivery" | "edit"
export default function LotSelectorModal({ lots, mode = "add", onSelect, onAddNewLot, onClose }) {
  const first = lots[0] || {};
  const today = new Date().toISOString().slice(0, 10);
  const isRemoval = ["remove", "workOrder", "delivery"].includes(mode);

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.title}>Select Lot</div>
          <button onClick={onClose} className={styles.closeBtn}>x</button>
        </div>

        <div className={styles.productSummary}>
          <div className={styles.productBarcode}>{first.barcode}</div>
          <div className={styles.productDesc}>{first.description}</div>
          <div className={styles.productMfg}>{first.manufacturer}</div>
        </div>

        <div className={styles.lotList}>
          {lots.map(lot => {
            const isExpired = lot.expiryDate && lot.expiryDate < today;
            const isDimmed = isRemoval && (lot.stock || 0) === 0;

            return (
              <button
                key={lot.id}
                className={`${styles.lotCard} ${isDimmed ? styles.lotCardDimmed : ""}`}
                onClick={() => !isDimmed && onSelect(lot)}
                disabled={isDimmed}
              >
                <div className={styles.lotInfo}>
                  <div className={styles.lotNumber}>LOT: {lot.lotNumber}</div>
                  <div className={`${styles.lotExpiry} ${isExpired ? styles.expired : ""}`}>
                    EXP: {lot.expiryDate ? formatExpiryDate(lot.expiryDate) : "N/A"}
                    {isExpired && <span className={styles.expiredBadge}>EXPIRED</span>}
                  </div>
                </div>
                <div className={styles.lotStock}>
                  <div className={
                    lot.stock > 10 ? styles.stockGood :
                    lot.stock > 0 ? styles.stockWarn : styles.stockDanger
                  }>
                    {lot.stock}
                  </div>
                  <div className={styles.stockLabel}>in stock</div>
                </div>
              </button>
            );
          })}
        </div>

        {mode === "add" && onAddNewLot && (
          <button onClick={onAddNewLot} className={styles.addNewBtn}>
            + ADD NEW LOT
          </button>
        )}
      </div>
    </div>
  );
}
